export function SettingsPlan() {
  return (
    <div className="rounded-lg border border-dashed border-slate-300 bg-white p-12 text-center">
      <p className="text-sm font-medium text-slate-700">Plan &amp; billing arrive in Phase 7</p>
      <p className="mt-1 text-xs text-slate-500">Single-tier launch. Tiered plans land alongside Stripe.</p>
    </div>
  );
}
